var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-flex tw-flex-col tw-gap-2"},[_c('div',{staticClass:"tw-h-6 tw-rounded-full tw-bg-gray-300 tw-animate-pulse tw-w-full"}),_c('div',{staticClass:"tw-grid tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 lg:tw-gap-6"},_vm._l((6),function(i){return _c(_setup.SkeletonCompHintsCard,{key:i})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }